//
// Copyright (c) 2011-2025 by Curalate, Inc.
//
import React from 'react';
import { useSelector } from 'react-redux';

import { AgentsBetaBadge } from '@agents-dashboard/components/common/AgentsBetaBadge';
import { getIsAgentsDashboardEnabled } from '@agents-dashboard/selectors/getIsAgentsDashboardEnabled';
import { NavMenuItem } from '@legacy-components/nav3/navigation-menus/NavMenuItem';
import { NAV_MENU_ITEMS_TRACKING_ID } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';

import { NavGroup } from 'app/initialization/routing/stateHelpers';

export const AgentsDashboardNav = () => {
  const isAgentsDashboardEnabled = useSelector(getIsAgentsDashboardEnabled);

  if (!isAgentsDashboardEnabled) {
    return null;
  }

  return (
    <NavMenuItem
      activeNavGroup={NavGroup.AGENTS}
      state='agentsDashboard'
      trackingId={NAV_MENU_ITEMS_TRACKING_ID.AGENTS_DASHBOARD_NAV}
    >
      Agents
      <AgentsBetaBadge />
    </NavMenuItem>
  );
};
